import { useCallback, useMemo } from 'react';

import { imageHelpers } from '@nocowanie/core/helpers';

import { environment } from '@app/environments/environment';

/**
 * Hook that returns wpresizer with multiplier
 */
export const useWpResizer = () => {
    const { buildWpResizerUrl } = imageHelpers;

    const envValue = environment.IMAGE_MULTIPLIER;
    const multiplier = useMemo(() => Number(envValue || 1), [envValue]);

    const wpresizer = useCallback<imageHelpers.WpResizerFn>(
        (size, url) => buildWpResizerUrl(size, url, multiplier),
        [multiplier],
    );

    return wpresizer;
};
